<div class="row h650">




  <div class="col-md-6 h600">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">

      <div class="box-header text-center">
        <h3 class="box-title ">Irregularidades Cadastradas</h3><br />
        <span class="text-muted">Selecione para editar</span>

        <div class="divider"></div>

        <div class="input-group input-group-sm">
          <div class="input-group-prepend">
            <button class="btn" type="button" (click)="search(parametro.value, 1)"
              [ngClass]="{'btn-info' : this.filtredByTipo == 1, 'btn-light' : this.filtredByTipo != 1}"
              title="Filtrar por Falha"><i class="fa fa-exclamation-triangle"></i></button>
            <button class="btn btn-light" type="button" (click)="search(parametro.value, 2)"
              [ngClass]="{'btn-info' : this.filtredByTipo == 2, 'btn-light' : this.filtredByTipo != 2}"
              title="Filtrar por Pendência encontrada"><i class="fa fa-exclamation-circle"></i></button>
          </div>
          <input type="text" class="form-control" #parametro id="parametro" placeholder="busca" maxlength="30">
          <div class="input-group-append">
            <button class="btn btn-light" type="button" (click)="search(parametro.value, 0)" title="buscar"><i
                class="fa fa-search pr-1 pl-1"></i></button>
            <button class="btn btn-light" type="button" title="limpar/remover filtro" (click)="clearSearch()"><i
                class="fa fa-times pr-1 pl-1"></i></button>
          </div>
        </div>

      </div>

      <div class="box-body">

        <div class="box-table h450">
          <table>
            <thead>
              <tr>
                <th class="text-center w180">Descricao</th>
                <th class="text-center">Classificação</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of cadastrados" class="cp" (click)="read(c.id)"
                [ngClass]="{'tr-info': c.id == this.form.get('id').value}">
                <td>{{ c.descricao }}</td>
                <td>{{ c.classificacaoStr }}</td>
              </tr>
              <tr *ngFor="let v of this.voids">
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="box-footer">
        <span class="pl-1">Total: <b>{{ this.cadastrados?.length }}</b> </span>
        <span *ngIf="this.isFiltered" class="pl-3 text-primary">(filtrados)</span>
      </div>
    </div>
  </div>

  <div class="col-md-6">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">

      <div class="box-body h650" >


        <form novalidate style="padding-top: 30px;" [formGroup]="form" id="form" (validSubmit)="submit()">

          <div class="form-row">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <div class="position-relative form-group">
                <label for="descricao">Descrição</label>
                <input class="form-control" formControlName="descricao" type="text" maxlength="50" (change)="updateDescricaoAbreviada()" />
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small *ngIf="form.get('descricao').hasError('isNotUniqueDescricaoIrregularidade')">Esta descrição de irregularidade
                    já está em uso</small>
                </section>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-1"></div>
            <div class="col-md-6">
              <div class="position-relative form-group">
                <label for="descricaoAbreviada">Descrição abreviada</label>
                <input class="form-control" formControlName="descricaoAbreviada" type="text" maxlength="19" />
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small *ngIf="form.get('descricaoAbreviada').hasError('isNotUniqueDescricaoAbreviadaIrregularidade')">Esta descricao abreviada de irregularidade
                    já está em uso</small>
                </section>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-1"></div>
            <div class="col-md-5">
              <div class="position-relative form-group">
                <label for="classificacao">Classificação</label>
                <select class="form-control" formControlName="classificacao" required>
                  <option value="">selecione</option>
                  <option value="F">Falha</option>
                  <option value="P">Pendência encontrada</option>
                </select>
              </div>
            </div>
          </div>
        </form>


      </div>

      <div class="text-center">
        <app-ball-pulse *ngIf="isProcessing"></app-ball-pulse>
      </div>


    </div>

  </div>
</div>


<div class="row mt-3">
  <div class="col-md-12">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">
      <div class="box-body">
        <div class="row">
          <div class="col-md-4">
            <div class="d-flex justify-content-start">
              <button type="button" 
                class="btn btn-light pl-3 pr-3 mr-3" 
                [disabled]="!(this.isEditing && this.autorizacoes?.podeExcluir)" 
                title="Exluir funcionário selecionado" (click)="showModalSm(modaldelete)">
                <span class="text-danger"><i class="fa fa-trash"></i></span><span class="pl-3">Excluir</span>
              </button>
            </div>
          </div>
          <div class="col-md-4">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
            </div>
          </div>
          <div class="col-md-4">

            <div class="d-flex justify-content-end">

              <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="reset()">Limpar</button>
              <button type="submit" class="btn pl-5 pr-5 mr-3 btn-shadow" form="form"
                [disabled]="(!(!this.isEditing && this.autorizacoes?.podeIncluir) && !(this.isEditing && this.autorizacoes?.podeAlterar))"
                [ngClass]="{'btn-primary': !this.isEditing, 'btn-warning': this.isEditing }">
                <span *ngIf="!this.isEditing">Cadastrar</span>
                <span *ngIf="this.isEditing">Editar</span>
              </button>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>




<ng-template #modaldelete let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">SIGEM CLOUD</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-3">
        <div class="d-flex justify-content-center">
          <img src="assets\images\icon-question.png" />
        </div>
      </div>
      <div class="col-md-9">
        <div class="alert alert-warning">
          <div class="d-flex justify-content-center">
            <span class="question-modal pt-3 pb-3">Deseja excluir a <b>Irregularidade</b> selecionada?</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-md-6"></div>
      <div class="col-md-6">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="c('Close click')">Não</button>
          <button type="button" class="btn btn-primary btn-shadow pl-5 pr-5 mr-2"
            (click)="delete(this.form.get('id').value, c)">Sim</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>